import { Text, Visible } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const FidelityProgram = ({
  howItWorksUrl = '',
  alreadyInUrl = '',
  imageUrl = ''
}) => (
  <S.Wrapper>
    <div>
      <S.Title size="giga" bold>
        Programa de Fidelidade Leroy Merlin Com Você
      </S.Title>

      <Text size="mega">
        Comprando na Leroy Merlin, você acumula pontos e pode aproveitar nossos
        descontos exclusivos!
      </Text>

      <S.Button
        appearance="primary"
        as="a"
        href={howItWorksUrl}
        size="mega"
        isDisabled={!howItWorksUrl}
        isStretch
      >
        Quero fazer parte
      </S.Button>

      <S.Button
        variant="ghost"
        as="a"
        href={alreadyInUrl}
        size="mega"
        isDisabled={!alreadyInUrl}
        isStretch
      >
        Já faço parte
      </S.Button>
    </div>
    <Visible giga tera>
      <S.Image url={imageUrl} />
    </Visible>
  </S.Wrapper>
)

export default FidelityProgram
